module.exports = __webpack_public_path__ + "static/img/section-2.a2381b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/section-2.jpg
// module id = VXpN
// module chunks = 0